import _ from 'lodash';
import React from 'react';
import { NavLink } from 'fluxible-router';
import shallowCompare from '../../lib/shallowCompare';
import InventorySearch from '../InventorySearch';
import AccountSettingsModal from '../AccountSettingsModal';
import MarketingRegisterModal from '../MarketingRegisterModal';
import AuthPopover from '../AuthPopover';
import BookmarksPopover from '../BookmarksPopover';
import ShoppingCartPopover from '../ShoppingCartPopover';
import Customer from '../../models/Customer';
import Store from '../../models/Store';
import ShoppingCart from '../../models/ShoppingCart';
import SecondaryNavbar from './SecondaryNavbar';
import styles from './index.sass';
import AcceptCookies from '../../components/AcceptCookies';
import banquetLogoPng from '../images/banquet_logo_2x.png';
import banquetLogoSvg from '../images/banquet_logo.svg';
import whiteBanquetLogoPng from '../images/banquet_white_logo_2x.png';
import whiteBanquetLogoSvg from '../images/banquet_white_logo.svg';

class Navbar extends React.Component {
  static propTypes = {
    customer: React.PropTypes.instanceOf(Customer),
    store: React.PropTypes.instanceOf(Store),
    shoppingCart: React.PropTypes.instanceOf(ShoppingCart),
    currentRoute: React.PropTypes.object
  };

  static defaultProps = {
    store: null
  };

  static contextTypes = {
    executeAction: React.PropTypes.func,
    getUserAgent: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      menuIsOpen: false,
      menuIsClosing: false,
      searchInputOpen: (props.currentRoute && (props.currentRoute.name === 'search' || props.currentRoute.name === 'universalSearch') && this.hasStringifiedFilters(props.currentRoute.query)),
      showAccountSettingsModal: false,
      showMarketingRegisterModal: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.currentRoute !== this.props.currentRoute) {
      if((this.props.currentRoute.name === 'search' && nextProps.currentRoute.name !== 'search') || (this.props.currentRoute.name === 'universalSearch' && nextProps.currentRoute.name !== 'universalSearch')) {
        this.setState({searchInputOpen: false});
      }
      if(this.state.menuIsOpen) {
        this.closeMenu();
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(!prevState.menuIsOpen && this.state.menuIsOpen) {
      document.body.scrollTop = 0;
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
    }
    else if(prevState.menuIsOpen && !this.state.menuIsOpen) {
      document.body.style.overflow = '';
      document.body.style.width = '';
      document.body.style.position = '';
    }
  }

  hasStringifiedFilters(query) {
    // Only text
    if(!query.f) {return false;}
    let matches = query.f.match(/[,]?(q:)/);
    return !!(matches && matches.length);
  }

  handleOnClickMenuButton(e) {
    if(this.state.menuIsOpen) {
      this.closeMenu();
    } else {
      this.setState({menuIsOpen: true});
    }
  }

  handleOnClickSettingsLink(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({showAccountSettingsModal: true});
    this.closeMenu();

    return;
  }

  handleOnClickGetStarted(e) {
    this.setState({showMarketingRegisterModal: true});
    this.closeMenu();
  }

  handleOnClickMenuOverlay(e) {
    this.closeMenu();
  }

  handleOnCloseAccountSettingsModal() {
    this.setState({showAccountSettingsModal: false});
  }

  handleOnCloseMarketingRegisterModal() {
    this.setState({showMarketingRegisterModal: false});
  }

  handleOnOpenSearchInput(searchInputOpen) {
    this.setState({searchInputOpen});
    if(searchInputOpen && this.state.menuIsOpen) {
      this.closeMenu();
    }
  }

  closeMenu() {
    this.setState({menuIsClosing: true});

    setTimeout(() => {
      this.setState({
        menuIsOpen: false,
        menuIsClosing: false
      });
    }, 300);
  }

  renderAccountSettingsModal() {
    if(!this.state.showAccountSettingsModal) {return;}
    let modalProps = {
      onClose: this.handleOnCloseAccountSettingsModal.bind(this),
      store: this.props.store
    };
    return <AccountSettingsModal {...modalProps} />;
  }

  renderMarketingRegisterModal() {
    if(!this.state.showMarketingRegisterModal) {return;}
    let modalProps = {
      onClose: this.handleOnCloseMarketingRegisterModal.bind(this)
    };
    return <MarketingRegisterModal {...modalProps} />;
  }

  renderMobileMenu() {
    return (
      <div className={styles.menu}>
        <ul>
          <li className={styles.menuItem}>
            <NavLink className={styles.menuLink} href="/" activeClass={styles.active}>Home</NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink className={styles.menuLink} href="/sell-on-banquet" activeClass={styles.active}>Sell on Banquet</NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink className={styles.menuLink} href="/customers" activeClass={styles.active}>Customers</NavLink>
          </li>
          <li className={styles.menuItem}>
            <button className={styles.menuLink} onClick={this.handleOnClickGetStarted.bind(this)}>Get started</button>
          </li>
        </ul>
        <div className={styles.menuOverlay} onClick={this.handleOnClickMenuOverlay.bind(this)} />
      </div>
    );
  }

  renderMobileStoreMenu() {
    let { customer, currentRoute } = this.props;
    let isSignedIn = customer.isSignedIn();
    let shopLinkProps = {
      className: `${styles.shopLink} ${currentRoute.name === 'store'}`,
      routeName: 'storeLandingPage',
      activeClass: styles.active
    };
    let savedLinkProps = {
      className: `${styles.savedLink} ${currentRoute.name === 'saved'}`,
      routeName: 'saved',
      activeClass: styles.active
    };
    let orderHistoryLinkProps = {
      className: `${styles.orderHistoryLink} ${currentRoute.name === 'orderHistory'}`,
      routeName: 'orderHistory',
      activeClass: styles.active
    };
    let settingsLinkProps = {
      className: `${styles.settingsLink}`,
      routeName: 'settings',
      onClick: this.handleOnClickSettingsLink.bind(this)
    };
    let authLinkProps = {
      className: styles.authLink + (isSignedIn ? (` ${styles.signedIn}`) : ''),
      routeName: isSignedIn ? 'signOut' : 'signIn',
      activeClass: styles.active
    };
    return (
      <div className={styles.menu}>
        <ul>
          <li className={styles.menuItem}>
            <NavLink {...shopLinkProps}>Shop</NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink {...savedLinkProps}>Saved</NavLink>
          </li>
          {isSignedIn ? <li className={styles.menuItem}>
              <NavLink {...orderHistoryLinkProps}>Order History</NavLink>
            </li> : null}
          {isSignedIn ? <li className={styles.menuItem}>
              <a {...settingsLinkProps}>Settings</a>
            </li> : null}
        </ul>
        <NavLink {...authLinkProps}>{isSignedIn ? 'Sign out' : 'Sign in / Sign up'}</NavLink>
      </div>
    );
  }

  render() {
    let { currentRoute, customer, shoppingCart, store } = this.props;
    let { menuIsOpen, menuIsClosing, searchInputOpen } = this.state;
    let useragent = this.context.getUserAgent();
    let classes = styles.navbar;

    if(useragent.isMobile) {
      if(menuIsClosing) {
        classes += ` ${styles.menuClosing}`;
      } else if(menuIsOpen) {
        classes += ` ${styles.menuOpen}`;
      }
    }

    let menuButtonProps = {
      className: styles.menuButton,
      onClick: this.handleOnClickMenuButton.bind(this)
    };
    let inventorySearchProps = {
      currentRoute,
      searchInputOpen,
      store,
      onOpenSearchInput: this.handleOnOpenSearchInput.bind(this)
    };
    let authPopoverProps = { customer, store, currentRoute };

    if(store) {
      classes += ` ${styles.storeNavbar}`;

      let bookmarksPopoverProps = { store, currentRoute };
      let shoppingCartPopoverProps = { store, shoppingCart, currentRoute };
      let storeLink = (
        <NavLink className={styles.storeLink} routeName="storeLandingPage" navParams={{}}>
          <img className={styles.storeLogo} src={store.logo_photo_hash.getClosestToTarget(200)} />
        </NavLink>
      );

      if(useragent.isMobile) {
        if(searchInputOpen) {
          storeLink = null;
        }

        return (
          <nav className={classes}>
            <div className={styles.innerContainer}>
              <button {...menuButtonProps} />
              <div className={styles.expandingWrapper}>
                {storeLink}
                <InventorySearch {...inventorySearchProps} />
              </div>
              <ShoppingCartPopover {...shoppingCartPopoverProps} />
            </div>
            {this.renderMobileStoreMenu()}
            {this.renderAccountSettingsModal()}
          </nav>
        );
      }

      let secondaryNavbar;
      if(store.navigation.length) {
        classes += ` secondarynav`;
        let secondaryNavbarProps = { store };
        secondaryNavbar = <SecondaryNavbar {...secondaryNavbarProps} />;
      }

      return (
        <nav className={classes}>
          <div className={styles.innerContainer}>
            <span className={styles.desktopStoreLinkWrapper}>{storeLink}</span>
            <span className={styles.spacer} />
            <InventorySearch {...inventorySearchProps} />
            <span className={styles.spacer} />
            <AuthPopover {...authPopoverProps} />
            <BookmarksPopover {...bookmarksPopoverProps} />
            <ShoppingCartPopover {...shoppingCartPopoverProps} />
          </div>
          {secondaryNavbar}
        </nav>
      );
    }

    classes += ` ${styles.marketingNavbar}`;

    if (!currentRoute) {
      return null;
    }

    if(currentRoute.name === 'home') {
      classes += ` ${styles.transparent}`;
    }

    let tealLogoLink = (
      <NavLink className={styles.logoLink} href="/">
        <img className={styles.logo} src={banquetLogoPng} srcSet={banquetLogoSvg} />
      </NavLink>
    );
    let whiteLogoLink = (
      <NavLink className={styles.logoLink} href="/">
        <img className={styles.logo} src={whiteBanquetLogoPng} srcSet={whiteBanquetLogoSvg} />
      </NavLink>
    );

    // Generic (marketing pages)
    if(useragent.isMobile) {
      if(searchInputOpen) {
        tealLogoLink = null;
        whiteLogoLink = null;
      }

      return (
        <nav className={classes}>
          <div className={styles.innerContainer}>
            <button {...menuButtonProps} />
            <div className={styles.expandingWrapper}>
              {currentRoute.name === 'home' && (!menuIsOpen || menuIsClosing) ? whiteLogoLink : tealLogoLink}
              {currentRoute.name === 'home' ? <span className={styles.spacer} /> : <InventorySearch {...inventorySearchProps} />}
            </div>
          </div>
          {this.renderMobileMenu()}
          {this.renderMarketingRegisterModal()}
        </nav>
      );
    }

    return (
      <nav className={classes}>
        <AcceptCookies />
        <div className={styles.innerContainer}>
          {currentRoute.name === 'home' ? whiteLogoLink : tealLogoLink}
          <span className={styles.spacer} />
          {currentRoute.name === 'home' ? null : <InventorySearch {...inventorySearchProps} />}
          <span className={styles.spacer} />
          <NavLink className={styles.link} activeClass={styles.active} href="/sell-on-banquet">Sell on Banquet</NavLink>
          <AuthPopover {...authPopoverProps} />
        </div>
        {this.renderMarketingRegisterModal()}
      </nav>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// banquet/components/Navbar/index.js